// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#nav-button-container[data-v-3b246eb6]{justify-content:center;text-align:center}.nav-button[data-v-3b246eb6]{width:60%;margin:.5em 0}@media(min-width: 769px){#nav-button-container[data-v-3b246eb6]{display:block;margin:1em 0;text-align:left;justify-content:space-between}.nav-button[data-v-3b246eb6]{padding:1em 5em;margin:.5em;width:30%}.nav-button#back_button[data-v-3b246eb6]{margin-left:0}}", ""]);
// Exports
module.exports = exports;
